class CartRemoveButton extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('click', (event) => {
      event.preventDefault();
      const cartItems = this.closest('cart-items') || this.closest('cart-drawer-items');
      cartItems.updateQuantity(this.dataset.index, 0);
    });
  }
}

customElements.define('cart-remove-button', CartRemoveButton);

class CartItems extends HTMLElement {
  constructor() {
    super();

    this.lineItemStatusElement = document.getElementById('shopping-cart-line-item-status') || document.getElementById('CartDrawer-LineItemStatus');

    this.currentItemCount = Array.from(this.querySelectorAll('[name="updates[]"]'))
      .reduce((total, quantityInput) => total + parseInt(quantityInput.value), 0);

    this.debouncedOnChange = debounce((event) => {
      this.onChange(event);
    }, 300);

    this.addEventListener('change', this.debouncedOnChange.bind(this));
  }

  async onChange(event) {
    let cart = await fetch("/cart.js");
    cart = await cart.json();

    if (event.target.classList.contains('subscribe-item-checkbox')) {
      let containerEl = event.target.closest('.subscribe-activate');
      let item_id = event.target.dataset.subscription_variant_id;
      let original_item_id = event.target.dataset.original_item_id;
      let shipping_interval_frequency = event.target.dataset['shipping_interval_frequency'];
      let quantityEl = event.target.closest('.cart-item').querySelector('.quantity__input');

      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];

      const formData = new FormData();
      formData.append('form_type', 'product');
      formData.append('utf8', '✓');
      formData.append('id', item_id);
      formData.append('purchase_type', 'autodeliver');
      formData.append('quantity', quantityEl.value);
      formData.append('properties[shipping_interval_frequency]', shipping_interval_frequency);
      formData.append('properties[shipping_interval_unit_type]', 'Weeks');
      formData.append('properties[prepay_subscription_type]', 'payg');
      formData.append('properties[charge_interval_frequency]',shipping_interval_frequency);

      let propertyEls = containerEl.querySelectorAll('.line-item-property[type="hidden"]');
      if (propertyEls.length) {
        propertyEls.forEach((el) => {
          //properties[el.getAttribute("name")] = el.value;
          if(el.getAttribute("name") == "product_type"){
            formData.append(`properties[${el.getAttribute("name")}]`, "subscription");
          }else{
            formData.append(`properties[${el.getAttribute("name")}]`, el.value);
          }
        });
      }

      let cartElement = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      if (cartElement) {
        formData.append('sections', cartElement.getSectionsToRender().map((section) => section.id));
        formData.append('sections_url', window.location.pathname);
        cartElement.setActiveElement(document.activeElement);
      }
      
      config.body = formData;

      //this.updateToSubscribeProduct(event.target.dataset.index, 0);

      let removeFormData = {
        'id': original_item_id,
        'quantity': 0      
      };
      
      fetch(window.Shopify.routes.root + 'cart/change.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify(removeFormData)
        })
        .then(response => {
          return response.json();
        })
        .catch((error) => {
          console.error('Error:', error);
        })
        .finally(() => {
          fetch(`${routes.cart_add_url}`, config)
            .then((response) => response.json())
            .then((response) => {
              // if (response.status) {
              //   this.handleErrorMessage(response.description);

              //   const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              //   if (!soldOutMessage) return;
              //   this.submitButton.setAttribute('aria-disabled', true);
              //   this.submitButton.querySelector('span').classList.add('hidden');
              //   soldOutMessage.classList.remove('hidden');
              //   this.error = true;
              //   return;
              // } else if (!this.cart) {
              //   window.location = window.routes.cart_url;
              //   return;
              // }

              this.error = false;
              
              cartElement.renderContents(response);
            })
            .catch((e) => {
              console.error(e);
            })
            .finally(() => {
              
            });
        });


    } else {
      this.updateQuantity(event.target.dataset.index, event.target.value, document.activeElement.getAttribute('name'),cart);
    }
  }

  getSectionsToRender() {
    return [
      {
        id: 'main-cart-items',
        section: document.getElementById('main-cart-items').dataset.id,
        selector: '.js-contents',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section'
      },
      {
        id: 'cart-live-region-text',
        section: 'cart-live-region-text',
        selector: '.shopify-section'
      },
      {
        id: 'main-cart-footer',
        section: document.getElementById('main-cart-footer').dataset.id,
        selector: '.js-contents',
      }
    ];
  }

  updateQuantity(line, quantity, name, cart) {
    this.enableLoading(line);
    //disable the checkout button. wait for the recharge load.
    //let checkout_btn = document.querySelector('#CartDrawer-Checkout');
    //checkout_btn.disabled = true;
    var body;
    if(cart){
      let properties = cart.items.at(line-1).properties;
  
      if(properties.fulfillable_quantity && properties.shipping_interval_frequency){
        properties.fulfillable_quantity = "" + parseInt(properties.shipping_interval_frequency)/4 * parseInt(quantity);
      }else if(properties.fulfillable_quantity && properties.fulfillable_base){
        properties.fulfillable_quantity = "" + parseInt(properties.fulfillable_base) * parseInt(quantity);
      }

      body = JSON.stringify({
        line,
        quantity,
        sections: this.getSectionsToRender().map((section) => section.section),
        sections_url: window.location.pathname,
        properties
      });
    }else{
      body = JSON.stringify({
        line,
        quantity,
        sections: this.getSectionsToRender().map((section) => section.section),
        sections_url: window.location.pathname,
      });
    }

    fetch(`${routes.cart_change_url}`, {...fetchConfig(), ...{ body }})
      .then((response) => {
        return response.text();
      })
      .then((state) => {
        const parsedState = JSON.parse(state);
        this.classList.toggle('is-empty', parsedState.item_count === 0);
        const cartDrawerWrapper = document.querySelector('cart-drawer');
        const cartFooter = document.getElementById('main-cart-footer');

        if (cartFooter) cartFooter.classList.toggle('is-empty', parsedState.item_count === 0);
        if (cartDrawerWrapper) cartDrawerWrapper.classList.toggle('is-empty', parsedState.item_count === 0);

        this.getSectionsToRender().forEach((section => {
          const elementToReplace =
            document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);
          elementToReplace.innerHTML =
            this.getSectionInnerHTML(parsedState.sections[section.section], section.selector);
        }));

        // let checkout_btn = document.querySelector('#CartDrawer-Checkout');
        // checkout_btn.disabled = true;

        this.updateLiveRegions(line, parsedState.item_count);
        const lineItem =  document.getElementById(`CartItem-${line}`) || document.getElementById(`CartDrawer-Item-${line}`);
        if (lineItem && lineItem.querySelector(`[name="${name}"]`)) {
          cartDrawerWrapper ? trapFocus(cartDrawerWrapper, lineItem.querySelector(`[name="${name}"]`)) : lineItem.querySelector(`[name="${name}"]`).focus();
        } else if (parsedState.item_count === 0 && cartDrawerWrapper) {
          trapFocus(cartDrawerWrapper.querySelector('.drawer__inner-empty'), cartDrawerWrapper.querySelector('a'))
        } else if (document.querySelector('.cart-item') && cartDrawerWrapper) {
          trapFocus(cartDrawerWrapper, document.querySelector('.cart-item__name'))
        }
        this.disableLoading();

        rechargeCheckoutBtn();
      }).catch(() => {
        this.querySelectorAll('.loading-overlay').forEach((overlay) => overlay.classList.add('hidden'));
        const errors = document.getElementById('cart-errors') || document.getElementById('CartDrawer-CartErrors');
        if (errors) {
        errors.textContent = window.cartStrings.error;
        }
        this.disableLoading();
      });
  }

  updateLiveRegions(line, itemCount) {
    if (this.currentItemCount === itemCount) {
      const lineItemError = document.getElementById(`Line-item-error-${line}`) || document.getElementById(`CartDrawer-LineItemError-${line}`);
      const quantityElement = document.getElementById(`Quantity-${line}`) || document.getElementById(`Drawer-quantity-${line}`);

      lineItemError
        .querySelector('.cart-item__error-text')
        .innerHTML = window.cartStrings.quantityError.replace(
          '[quantity]',
          quantityElement.value
        );
    }

    this.currentItemCount = itemCount;
    this.lineItemStatusElement.setAttribute('aria-hidden', true);

    const cartStatus = document.getElementById('cart-live-region-text') || document.getElementById('CartDrawer-LiveRegionText');
    cartStatus.setAttribute('aria-hidden', false);

    setTimeout(() => {
      cartStatus.setAttribute('aria-hidden', true);
    }, 1000);
  }

  getSectionInnerHTML(html, selector) {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector).innerHTML;
  }

  enableLoading(line) {
    const mainCartItems = document.getElementById('main-cart-items') || document.getElementById('CartDrawer-CartItems');
    mainCartItems.classList.add('cart__items--disabled');

    const cartItemElements = this.querySelectorAll(`#CartItem-${line} .loading-overlay`);
    const cartDrawerItemElements = this.querySelectorAll(`#CartDrawer-Item-${line} .loading-overlay`);

    [...cartItemElements, ...cartDrawerItemElements].forEach((overlay) => overlay.classList.remove('hidden'));

    document.activeElement.blur();
    this.lineItemStatusElement.setAttribute('aria-hidden', false);
  }

  disableLoading() {
    const mainCartItems = document.getElementById('main-cart-items') || document.getElementById('CartDrawer-CartItems');
    if (mainCartItems) {
      mainCartItems.classList.remove('cart__items--disabled');
    }
  }
}

customElements.define('cart-items', CartItems);

if (!customElements.get('cart-note')) {
  customElements.define('cart-note', class CartNote extends HTMLElement {
    constructor() {
      super();

      this.addEventListener('change', debounce((event) => {
        const body = JSON.stringify({ note: event.target.value });
        fetch(`${routes.cart_update_url}`, {...fetchConfig(), ...{ body }});
      }, 300))
    }
  });
};
